/**
 * Enquanto `users.trocarSenhaNoProximoAcesso` estiver ligado, qualquer tela leva
 * à troca de senha (D32, PLANO-2 da importação de praticantes).
 *
 * A marca nasce nos logins criados pela importação com a data de nascimento
 * como senha inicial (quem sabe CPF + nascimento de alguém entraria na conta
 * dela). O backend a apaga ao trocar a senha (`/api/usr/changepassword` e
 * `/sms-set-password`).
 */
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const LIVRES = ["/change-password", "/login", "/logout"];

export default function ExigirTrocaDeSenha() {
  const { currentUser } = useAuth();
  const { pathname } = useLocation();
  if (!currentUser?.trocarSenhaNoProximoAcesso) return null;
  if (LIVRES.some((p) => pathname.toLowerCase().endsWith(p))) return null;
  return <Navigate to="/change-password" replace state={{ obrigatoria: true }} />;
}
